export const MINERALS_ACTIONS = {
  SET_MINERALS: 'SET_MINERALS',
  SET_IS_LOADING: 'SET_IS_LOADING',
}
